var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"download-btn",on:{"click":function($event){_vm.$emit('download-item')}}},[_c('img',{staticClass:"download-btn-img",attrs:{"src":_vm.urlImage,"alt":_vm.alt}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e3d637c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diagnosis/download-btn.vue
// module id = 1189
// module chunks = 5 18 22 23